import React, { useState, useEffect } from "react";
import styled, { css } from "react-emotion";
import WebIcon from "../../../WebIcon";
import {
  withRedux,
  priceToDollars,
  isMobileDevice,
  getSortedDataToDisplay,
} from "helpers";
import { Modal } from "@material-ui/core";
import QtyInput from "../../CartWebComponent/CartUtil/QtyInput";
import NewReleasesOutlinedIcon from "@material-ui/icons/NewReleasesOutlined";
import AdditionalOptionsItemsGroup from "./AdditionalOptionsItemsGroup";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ProductInfoModal from "./ProductInfoModal";

const isMob = isMobileDevice();

const productCardLink = css`
  position: relative;
  display: block;
  color: #2e2d2b;
  text-decoration: none;
  text-align: center;

  transition: transform 0.2s ease-in-out;
  :hover {
    transform: scale(1.05);
  }
  cursor: pointer;
  @media (max-width: 768px) {
    border: 1px solid #ebebeb;
    border-radius: 4px;
    padding: 10px 0px;
  }
`;

const productCardInfo = css`
  position: relative;
  padding-top: 2.4rem;
  padding-right: 1rem;
  padding-left: 1rem;
  text-align: center;
  z-index: 1;
  /* margin-top: 1.2rem;
  margin-bottom: 2.4rem; */
  background-color: #fff;
  text-align: left;
`;

const productPrice = css`
  padding-top: 0.2rem;
  font-size: 14px;
  /* margin-top: 10px; */
  font-weight: bold;
`;
const productName = css`
  height: ${isMob ? "auto" : "70px"};
  font-size: 1.125rem;
  line-height: 1.4375rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
  margin-top: 0.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  letter-spacing: 0.25px;
`;

const priceLabel = css`
  font-size: 1.125rem;
  line-height: 1.4375rem;
  font-weight: 700;
  letter-spacing: 0.25px;
  height: 1.4375rem;
`;

const row = css`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
`;

const productImageContainer = css`
  z-index: 2;
  flex: 1 1 0;
  /* margin: 1rem 0; */
  max-height: 14.5rem;
  position: relative;
  flex: 0 0 auto;
  align-self: center;
  width: 15rem;
  height: 15rem;
  align-items: center;
  justify-content: center;
  display: flex;
`;

const productImage = css`
  opacity: 1;
  transition: opacity 0.75s ease;
  position: absolute;
  z-index: 3;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 250px;
  height: 231px;
  object-fit: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

const productImageNullModal = css`
  width: 150px;
  height: 131px;
  object-fit: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-top: 40px;
`;

const productDescription = css`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: ${isMob ? "auto" : "60px"};
  margin-bottom: 15px;
  line-height: 19px;
`;

const AddToCartButton = styled("button")`
  color: ${(props) => props.color};
  border: ${(props) => "1px " + props.color + " solid"};
  width: 200px;
  padding: 10px;
  margin: auto;
  border-radius: 30px;
  margin-bottom: 5px;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`;

const ConfirmSpan = styled("span")`
  color: #4caf50;
  opacity: ${(props) => (props.show ? "100%" : "0")};
  transition: opacity 0.5s ease-in-out;
`;

const inlineBlock = css`
  display: inline-block;
`;

const smallText = css`
  font-size: 9px;
  height: auto;
`;

function Product(props) {
  const { storeItem, storeColor, cart, webStore, notify } = props;
  const {
    id: purchaseItemId,
    price: subtotal,
    title,
    maxPurchasesPerUser,
    totalPurchasesByUser,
    numberOfTotalPurchases,
    maxPurchasesTotal,
    additionalOptions,
  } = storeItem;

  const [show, setShow] = useState(false);
  const [cartItemChanged, setCartItemChanged] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const [error, setError] = useState("");

  // console.log("storeItemObject");
  // console.dir(storeItem);
  // console.log(storeItem.title);

  const toggleProductInfoModal = () => {
    setShowProductModal(!showProductModal);
  };

  const toggleChanged = () => {
    setCartItemChanged(!cartItemChanged);
  };

  const getNumItemsAlreadyInCart = () => {
    const { cartItems } = cart;
    const items = cartItems.filter(
      (item) => item.purchaseItemId === purchaseItemId
    );
    let numItemsAlreadyInCart = 0;
    items.forEach((item) => {
      numItemsAlreadyInCart += item.quantity;
    });
    return numItemsAlreadyInCart;
  };

  const getRemainingPurchaseInfo = (numOfItemsAlreadyInCart) => {
    // console.log("calculating remaining purchase info for: " + title);
    let purchasesRemaining = null;
    let maxPurchasesReached = false;
    let soldOut = false;

    // because items might already be in cart, we should could those as "purchased"
    let totalEffectivePurchasesByUser =
      (totalPurchasesByUser ? totalPurchasesByUser : 0) +
      numOfItemsAlreadyInCart;

    // check if each user is limited to an amount
    if (maxPurchasesPerUser != null && maxPurchasesPerUser > 0) {
      // check if user has hit max
      if (totalEffectivePurchasesByUser >= maxPurchasesPerUser) {
        maxPurchasesReached = true;
        purchasesRemaining = 0;
      } else {
        // calculate how many purchases user has remaining
        purchasesRemaining =
          maxPurchasesPerUser - totalEffectivePurchasesByUser;
      }
    }

    let effectiveCurrentTotalPurchases =
      (numberOfTotalPurchases ? numberOfTotalPurchases : 0) +
      numOfItemsAlreadyInCart;

    if (maxPurchasesTotal != null) {
      // there is a max number of total purchases for this - display accordingly
      if (effectiveCurrentTotalPurchases >= maxPurchasesTotal) {
        maxPurchasesReached = true;
        soldOut = true;
      } else {
        let purchasesUntilMaxAllowed =
          maxPurchasesTotal - effectiveCurrentTotalPurchases;

        if (purchasesRemaining != null) {
          // figure out which value is less between this and user purchase logic above
          purchasesRemaining = Math.min(
            purchasesRemaining,
            purchasesUntilMaxAllowed
          );
        } else {
          // user purchases not specified, use this value only
          purchasesRemaining = purchasesUntilMaxAllowed;
        }
      }
    }
    return { purchasesRemaining, maxPurchasesReached, soldOut };
  };

  const getAdditionalOptionsGroups = () => {
    const groups = [];
    additionalOptions.map((group) => {
      if (!group.retired) {
        groups.unshift(group);
      }
    });
    return groups;
  };

  const renderProductModal = () => {
    if (!showProductModal) return null;

    return (
      <Modal
        open={showProductModal}
        onClose={toggleProductInfoModal}
        disableBackdropClick={true}
        style={{
          width: isMob ? "98%" : "500px",
          marginLeft: "auto",
          marginRight: "auto",
          position: "fixed",
          top: "5%",
          bottom: "5%",
          overflowY: "auto",
        }}
      >
        <ProductInfoModal
          storeItem={storeItem}
          storeColor={storeColor}
          toggleProductInfoModal={toggleProductInfoModal}
          setShow={setShow}
          notify={notify}
          history={props.history}
          isAdmin={props.isAdmin}
        />
      </Modal>
    );
  };

  // console.log(storeItem.title);
  // console.log(storeItem.title.length);

  const purchaseItemInfo = getRemainingPurchaseInfo(getNumItemsAlreadyInCart());
  // console.dir(purchaseItemInfo);

  return (
    <a className={productCardLink}>
      {renderProductModal()}
      <div style={{ display: "flex", flexDirection: "column" }}>
        {" "}
        {storeItem.imageUrl ? (
          <div className={productImageContainer}>
            <div
              className={productImage}
              style={{ backgroundImage: "url(" + storeItem.imageUrl + ")" }}
            ></div>
          </div>
        ) : (
          <div className={productImageContainer}>
            <div
              className={productImage}
              style={{
                backgroundImage:
                  "url(https://mobile360-assets.s3.us-east-2.amazonaws.com/no_image.png)",
              }}
            ></div>
          </div>
        )}
        <div className={productCardInfo}>
          {/* <div className={productStoreName}>{storeName}</div> */}
          <div className={productName}> {storeItem.title} </div>
          <div>
            <p className={productPrice + " " + priceLabel}>
              {storeItem.price != 0 ? priceToDollars(storeItem.price) : ""}
            </p>
          </div>
          <div
            className={productPrice + " " + productDescription}
            style={{ fontWeight: "normal" }}
          >
            {storeItem.description}{" "}
          </div>

          <div
            style={{
              marginTop: isMob ? "0px" : "10px",
              marginBottom: isMob ? "0px" : "10px",
              textAlign: "center",
            }}
          >
            {/* <ConfirmSpan show={show}>
              Product Added!{" "}
              <WebIcon
                iconName={"checkMark"}
                useColor={true}
                size={"12px"}
                hover={false}
                className={inlineBlock}
                customColor={"#4caf50"}
              />
            </ConfirmSpan> */}
          </div>
        </div>
        {!purchaseItemInfo.maxPurchasesReached && (
          <div>
            <AddToCartButton
              color={storeColor}
              onClick={toggleProductInfoModal}
            >
              Add to Cart
            </AddToCartButton>
          </div>
        )}
        {purchaseItemInfo.soldOut && (
          <div style={{ marginTop: "10px", display: "flex" }}>
            {" "}
            <p className={productPrice} style={{ padding: "0rem 1rem" }}>
              Sold out!
            </p>
          </div>
        )}
        {purchaseItemInfo.purchasesRemaining > 0 && (
          <div style={{ marginTop: "10px", display: "flex" }}>
            {" "}
            <p className={productPrice} style={{ padding: "0rem 1rem" }}>
              Limit: {purchaseItemInfo.purchasesRemaining}
            </p>
          </div>
        )}
        {purchaseItemInfo.purchasesRemaining <= 0 &&
          maxPurchasesPerUser != null && (
            <div style={{ marginTop: "10px", display: "flex" }}>
              {" "}
              <p className={productPrice} style={{ padding: "0rem 1rem" }}>
                Purchased maximum times.
              </p>
            </div>
          )}
      </div>
    </a>
  );
}

export default withRedux(Product);
